module.exports = __webpack_public_path__ + "Roboto-Light.ea36cd9a0e9eee97012a.woff";


//////////////////
// WEBPACK FOOTER
// ./~/materialize-css/dist/fonts/roboto/Roboto-Light.woff
// module id = 575
// module chunks = 2